'use strict';

var _extends = require('@babel/runtime/helpers/extends');

var _defineProperty = require('@babel/runtime/helpers/defineProperty');

var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');

var React = require('react');

var injectSheet = require('react-jss');

var THEME = require('pobble-components/dist/theme');

var jssMixins = require('pobble-components/dist/jss-mixins');

var classNames = require('classnames');

var PropTypes = require('prop-types');

var _classCallCheck = require('@babel/runtime/helpers/classCallCheck');

var _createClass = require('@babel/runtime/helpers/createClass');

var _inherits = require('@babel/runtime/helpers/inherits');

var _possibleConstructorReturn = require('@babel/runtime/helpers/possibleConstructorReturn');

var _getPrototypeOf = require('@babel/runtime/helpers/getPrototypeOf');

var Tooltip = require('pobble-components/dist/tooltip');

var ExclamationIcon = require('react-icons/lib/fa/exclamation-circle');

var LockIcon = require('react-icons/lib/fa/lock');

var utils = require('pobble-components/dist/utils');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var _extends__default =
/*#__PURE__*/
_interopDefaultLegacy(_extends);

var _defineProperty__default =
/*#__PURE__*/
_interopDefaultLegacy(_defineProperty);

var _objectWithoutProperties__default =
/*#__PURE__*/
_interopDefaultLegacy(_objectWithoutProperties);

var React__default =
/*#__PURE__*/
_interopDefaultLegacy(React);

var injectSheet__default =
/*#__PURE__*/
_interopDefaultLegacy(injectSheet);

var THEME__default =
/*#__PURE__*/
_interopDefaultLegacy(THEME);

var classNames__default =
/*#__PURE__*/
_interopDefaultLegacy(classNames);

var PropTypes__default =
/*#__PURE__*/
_interopDefaultLegacy(PropTypes);

var _classCallCheck__default =
/*#__PURE__*/
_interopDefaultLegacy(_classCallCheck);

var _createClass__default =
/*#__PURE__*/
_interopDefaultLegacy(_createClass);

var _inherits__default =
/*#__PURE__*/
_interopDefaultLegacy(_inherits);

var _possibleConstructorReturn__default =
/*#__PURE__*/
_interopDefaultLegacy(_possibleConstructorReturn);

var _getPrototypeOf__default =
/*#__PURE__*/
_interopDefaultLegacy(_getPrototypeOf);

var Tooltip__default =
/*#__PURE__*/
_interopDefaultLegacy(Tooltip);

var ExclamationIcon__default =
/*#__PURE__*/
_interopDefaultLegacy(ExclamationIcon);

var LockIcon__default =
/*#__PURE__*/
_interopDefaultLegacy(LockIcon);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var COLORS$1 = THEME__default["default"].COLORS;
var styles$1 = {
  holder: {
    position: 'relative',
    width: '100%'
  },
  formTextArea: {
    '-webkit-appearance': 'none',
    minHeight: '40px',
    height: '80px',
    padding: '10px',
    border: '1px solid #ececec',
    borderRadius: '4px',
    transition: 'border-color 0.3s ease-in-out',
    width: '100%',
    color: '#999',
    resize: 'vertical',
    fontSize: '16px',
    '&:focus': {
      color: '#555',
      borderColor: COLORS$1.BLUE.NORMAL
    },
    '&hover': {
      color: '#777',
      borderColor: COLORS$1.BLUE.NORMAL
    },
    '&::placeholder': {
      color: '#BBBBBB'
    }
  },
  invalid: {
    '& $formTextArea': _objectSpread({
      backgroundColor: '#FEF7F6',
      borderColor: COLORS$1.RED.NORMAL,
      '&:focus': {
        borderColor: COLORS$1.RED.NORMAL
      }
    }, jssMixins.hover({
      borerColor: COLORS$1.RED.NORMAL
    }))
  },
  disabled: {
    '& $formTextArea': {
      cursor: 'default',
      backgroundColor: '#F9F9F9',
      borderColor: '#ECECEC !important',
      paddingRight: '34px'
    }
  },
  disabledIcon: {
    color: '#797979',
    position: 'absolute',
    right: '10px',
    top: '14px',
    pointerEvents: 'none'
  },
  invalidWithMessage: {
    '& $formTextArea': {
      paddingRight: '32px'
    }
  },
  validationError: {
    position: 'absolute',
    right: '10px',
    top: '13px'
  }
};
var COLORS = THEME__default["default"].COLORS;
var styles = {
  validationError: {
    width: '14px',
    zIndex: '20',
    height: '14px',
    color: COLORS.RED.NORMAL,
    '& svg': {
      display: 'block',
      width: '100%',
      height: '100%'
    }
  }
};

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf__default["default"](Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf__default["default"](this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn__default["default"](this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var ValidationError =
/*#__PURE__*/
function (_Component) {
  _inherits__default["default"](ValidationError, _Component);

  var _super = _createSuper(ValidationError);

  function ValidationError() {
    _classCallCheck__default["default"](this, ValidationError);

    return _super.apply(this, arguments);
  }

  _createClass__default["default"](ValidationError, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          className = _this$props.className,
          error = _this$props.error,
          style = _this$props.style;
      return (
        /*#__PURE__*/
        React__default["default"].createElement(Tooltip__default["default"], {
          style: style,
          className: classNames__default["default"](classes.validationError, className),
          content: error
        },
        /*#__PURE__*/
        React__default["default"].createElement(ExclamationIcon__default["default"], null))
      );
    }
  }]);

  return ValidationError;
}(React.Component);

var ValidationError$1 = injectSheet__default["default"](styles)(ValidationError);
var _excluded = ["classes", "textAreaProps", "className", "validationError", "autoFocus", "disabled"];

var FormTextArea = function FormTextArea(_ref) {
  var _classNames;

  var classes = _ref.classes,
      textAreaProps = _ref.textAreaProps,
      className = _ref.className,
      validationError = _ref.validationError,
      autoFocus = _ref.autoFocus,
      disabled = _ref.disabled,
      props = _objectWithoutProperties__default["default"](_ref, _excluded);

  return (
    /*#__PURE__*/
    React__default["default"].createElement("div", {
      className: classNames__default["default"](classes.holder, (_classNames = {}, _defineProperty__default["default"](_classNames, classes.invalid, validationError), _defineProperty__default["default"](_classNames, classes.disabled, disabled), _defineProperty__default["default"](_classNames, classes.invalidWithMessage, validationError && validationError !== true), _classNames))
    },
    /*#__PURE__*/
    React__default["default"].createElement("textarea", _extends__default["default"]({
      className: classNames__default["default"](classes.formTextArea, className),
      disabled: disabled,
      autoFocus: utils.isIOS ? false : autoFocus
    }, textAreaProps, props)), disabled &&
    /*#__PURE__*/
    React__default["default"].createElement(LockIcon__default["default"], {
      className: classes.disabledIcon
    }), validationError &&
    /*#__PURE__*/
    React__default["default"].createElement(ValidationError$1, {
      className: classes.validationError,
      error: validationError
    }))
  );
};

FormTextArea.propTypes = {
  /** Additional className if you want to restyle component */
  className: PropTypes__default["default"].string,

  /** Show validation error */
  validationError: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].bool]),

  /** Object with all additional textAreaProps props you want to pass. Check official textAreaProps documentation to get the idea what props os available */
  textAreaProps: PropTypes__default["default"].object
};
var index = injectSheet__default["default"](styles$1)(FormTextArea);
module.exports = index;